export var CIRCLE_TILE_WIDTH_PIXELS = {
    mobileAndAbove: 103.5,
    tabletAndAbove: 112,
    desktopAndAbove: 124
};
